import React, { FC, useState } from 'react';

import { Spacer, } from '@components/1-atoms';
import { AppTemplate } from '@components/4-templates';
import { IconButton } from '@components/2-molecules';
import { useAccount } from '@lib/hooks/useAccount';
import { ChartOfAccountsMenu, AccountList } from '@components/3-organisms';

import Sandwich from '@assets/icons/sandwich';
import Add from '@assets/icons/plus';
import {
  PageHeader
} from '@components/2-molecules';

import {STATE, ForwardedPageProps} from '@lib/constants';


const ChartOfAccounts: FC<ForwardedPageProps> = ({ navigation, data = {}, ...props }) => {

    const [accounts] = useAccount({state: STATE.READY});
    const [showMenu, setShowMenu] = useState(false);
    const toggleMenu = () => setShowMenu(!showMenu);

    return (
        <AppTemplate
            hooks={[accounts]}
             
        >
            
            <PageHeader title={"CHART OF ACCOUNTS"}
              left={<IconButton transparent icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
              menu={<ChartOfAccountsMenu navigation={navigation} />}
              menuIcon={<Add />}
            />
            <Spacer h={1} />
            
            <AccountList
              color={accounts?.data?.length ? '#000' : '#FFF'}
              data={accounts?.data}
            />

        </AppTemplate>
    );
};


import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
export default withForwardedNavigationParams<ForwardedPageProps>()(ChartOfAccounts);